import api from '../config/api';

class SessionService {
  // GET /v2/programs/:id/sessions — uncached, session-aware; returns the
  // caller's current session (incl. `service`) for the SLO logout decision.
  fetch = () => {
    return api.get(`/sessions`);
  };
}

export default SessionService;
